import React from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { BsTrash } from 'react-icons/bs';

const DeleteModal = (props) => {
  return (
    <Modal 
      show={props.showDeleteModal} 
      onHide={() => props.setShowDeleteModal(false)}
    >
      <Modal.Header closeButton>
        Delete {props.searchid}?
      </Modal.Header>
      <Modal.Body>
        Are you sure you wish to delete {props.searchid}?
      </Modal.Body>
      <Modal.Footer>
        <Button 
          onClick={() => props.setShowDeleteModal(false)}
          variant="outline-secondary"
        >
          Cancel
        </Button>
        <Button 
          variant="danger" 
          onClick={() => props.searchDeleteHandler()}
          disabled={props.fetchingData}
        >
          { props.fetchingData ? (
            <Spinner className='mr-1' animation='border' variant='light' size='sm' />
          ) : (
            <BsTrash className="mr-1" />
          )}
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteModal;